(function (global) {
  'use strict';

  var LINE_SELECTOR = '[data-tf-cart-multibuy-line]';
  var DISCLOSURE_SELECTOR = '[data-tf-bundle-disclosure]';
  var ALLOCATION_SELECTOR = '[data-tf-cart-discount-allocation]';
  var STATUS_SELECTOR = '[data-tf-cart-multibuy-status]';
  var CONTINUE_SHOPPING_SELECTOR = '[data-tf-cart-continue-shopping-copy]';

  function positiveWholeNumber(value) {
    return /^[1-9]\d*$/.test(value || '') ? Number(value) : null;
  }

  function nonNegativeWholeNumber(value) {
    return /^\d+$/.test(value || '') ? Number(value) : null;
  }

  function qualifyingPieceQuantity(lines) {
    var total = 0;
    for (var index = 0; index < lines.length; index += 1) {
      var line = lines[index];
      if (line.getAttribute('data-counts-toward-threshold') !== 'true') continue;
      var quantity = positiveWholeNumber(line.getAttribute('data-cart-quantity'));
      var pieces = positiveWholeNumber(line.getAttribute('data-physical-piece-count'));
      if (quantity === null || pieces === null || quantity > Number.MAX_SAFE_INTEGER / pieces) return null;
      total += quantity * pieces;
      if (!Number.isSafeInteger(total)) return null;
    }
    return total;
  }

  function displayPieceLabel(policy, currentTier, quantity) {
    var tiers = policy && policy.tiers;
    if (!Array.isArray(tiers) || !currentTier) return null;
    for (var index = 0; index < tiers.length; index += 1) {
      var tier = tiers[index];
      if (tier.minimumQuantity !== currentTier.minimumQuantity || tier.percentage !== currentTier.percentage) continue;
      return index === tiers.length - 1 ? String(tier.minimumQuantity) + '+' : String(quantity);
    }
    return null;
  }

  function cartPresentation(api) {
    var contract = api.readCartContract();
    var quantity = qualifyingPieceQuantity(global.document.querySelectorAll(LINE_SELECTOR));
    var progress;
    if (!contract || quantity === null) return null;
    progress = api.resolveProgress(contract.policy, quantity);
    if (!progress || progress.state !== 'active') return null;
    return { contract: contract, quantity: quantity, progress: progress };
  }

  function matchedAllocationAmountCents(allocations, api, percentage) {
    var total = 0;
    var matched = false;
    for (var index = 0; index < allocations.length; index += 1) {
      var allocation = allocations[index];
      var amount = nonNegativeWholeNumber(allocation.getAttribute('data-discount-amount-cents'));
      if (amount === null || !api.isCartAllocation(allocation.getAttribute('data-discount-title'), percentage)) continue;
      total += amount;
      if (!Number.isSafeInteger(total)) return null;
      matched = true;
    }
    return matched ? total : null;
  }

  function pluralizedPiece(count) {
    return count === 1 ? 'piece' : 'pieces';
  }

  function formatMoney(cents, status) {
    var currency = status.getAttribute('data-tf-cart-currency');
    var locale = status.getAttribute('data-tf-cart-locale') || undefined;
    if (!currency || !Number.isSafeInteger(cents) || cents < 0 || !global.Intl || typeof global.Intl.NumberFormat !== 'function') return null;
    try {
      return new global.Intl.NumberFormat(locale, { style: 'currency', currency: currency }).format(cents / 100);
    } catch (error) {
      return null;
    }
  }

  function setStatusCopy(status, selector, copy) {
    var element = status.querySelector(selector);
    if (!element) return;
    element.textContent = copy || '';
    element.hidden = !copy;
  }

  function enhanceCartStatus(api, presentation, allocations) {
    var statuses = global.document.querySelectorAll(STATUS_SELECTOR);
    var continues = global.document.querySelectorAll(CONTINUE_SHOPPING_SELECTOR);
    var currentTier = presentation && presentation.progress.currentTier;
    var nextTier = presentation && presentation.progress.nextTier;
    var remaining = presentation && presentation.progress.piecesRemainingToNextTier;
    var savings = currentTier ? matchedAllocationAmountCents(allocations, api, currentTier.percentage) : null;

    for (var index = 0; index < statuses.length; index += 1) {
      var status = statuses[index];
      var formattedSavings;
      if (!presentation || (!currentTier && !nextTier)) {
        status.hidden = true;
        continue;
      }
      status.hidden = false;
      formattedSavings = savings === null ? null : formatMoney(savings, status);
      setStatusCopy(status, '[data-tf-cart-multibuy-current]', currentTier ? presentation.quantity + ' qualifying ' + pluralizedPiece(presentation.quantity) + ' · ' + currentTier.percentage + '% off unlocked' + (formattedSavings === null ? '' : ' (Save ' + formattedSavings + ')') : '');
      setStatusCopy(status, '[data-tf-cart-multibuy-next]', nextTier && Number.isInteger(remaining) && remaining > 0 ? 'Add ' + remaining + ' more qualifying ' + pluralizedPiece(remaining) + ' to unlock ' + nextTier.percentage + '% off' : '');
    }

    for (var continueIndex = 0; continueIndex < continues.length; continueIndex += 1) {
      var button = continues[continueIndex];
      button.textContent = nextTier && Number.isInteger(remaining) && remaining > 0 ? 'Add ' + remaining + ' more ' + pluralizedPiece(remaining) + ' to save ' + nextTier.percentage + '%' : button.getAttribute('data-tf-cart-continue-shopping-default');
    }
  }

  function enhanceMultibuy() {
    var api = global.TheFaithMultibuy;
    var presentation;
    var percentage;
    var allocations;

    if (!api || typeof api.readCartContract !== 'function' || typeof api.resolveProgress !== 'function' || typeof api.isCartAllocation !== 'function' || !global.document) return;
    allocations = global.document.querySelectorAll(ALLOCATION_SELECTOR);
    presentation = cartPresentation(api);
    enhanceCartStatus(api, presentation, allocations);
    if (!presentation || !presentation.progress.currentTier) return;
    percentage = presentation.progress.currentTier.percentage;
    if (typeof percentage !== 'number' || !Number.isFinite(percentage)) return;
    for (var index = 0; index < allocations.length; index += 1) {
      var allocation = allocations[index];
      var title = allocation.getAttribute('data-discount-title');
      var amount = allocation.getAttribute('data-discount-amount');
      var copy = allocation.querySelector('[data-tf-cart-discount-copy]');
      if (!copy || !amount || !api.isCartAllocation(title, percentage)) continue;
      copy.textContent = percentage + '% off · Save ' + amount;
      allocation.classList.add('tf-cart-multibuy-discount');
    }
  }

  function toggleBundleDisclosure(button) {
    var id = button.getAttribute('aria-controls');
    var panel = id && global.document.getElementById(id);
    var expanded;
    if (!panel) return;
    expanded = button.getAttribute('aria-expanded') === 'true';
    button.setAttribute('aria-expanded', expanded ? 'false' : 'true');
    panel.hidden = expanded;
    var label = button.querySelector('[data-tf-bundle-disclosure-label]');
    if (label) label.textContent = (expanded ? 'View ' : 'Hide ') + button.getAttribute('data-piece-count') + ' pieces';
  }

  function init() {
    enhanceMultibuy();
    if (!global.document) return;
    global.document.addEventListener('click', function (event) {
      var button = event.target.closest && event.target.closest(DISCLOSURE_SELECTOR);
      if (!button) return;
      event.preventDefault();
      toggleBundleDisclosure(button);
    });
    // Prestige dispatches this bubbling event after it has replaced the drawer
    // children, so enhancement always targets the fresh cart markup.
    global.document.addEventListener('cart-drawer:refreshed', enhanceMultibuy);
  }

  global.TheFaithCartProductDisplay = {
    enhanceMultibuy: enhanceMultibuy,
    displayPieceLabel: displayPieceLabel,
    qualifyingPieceQuantity: qualifyingPieceQuantity,
    toggleBundleDisclosure: toggleBundleDisclosure
  };

  if (global.document && global.document.readyState === 'loading') global.document.addEventListener('DOMContentLoaded', init);
  else init();
})(typeof window !== 'undefined' ? window : globalThis);
